import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for LE LIS's "LE LIS MYSTERY BOX - 100 ASSORTED
// STYLES" (p_pucppp276r), read from that product's own live PDP
// (faire.com/product/p_pucppp276r) "Product reviews" section — not a
// brand-wide or similar-product fallback review.
export const review_ll2: FaireReviewEntity = {
  token: "review_ll2",
  type: "review",
  brandName: "LE LIS",
  brandToken: "b_q8gu9by5sv",
  productToken: "p_pucppp276r",
  reviewType: "product",
  reviewerName: "Ember",
  reviewerLocation: "Cedar Park, TX",
  stars: 5,
  reviewText:
    "This is the first time I've ordered a mystery box with them and I am more than pleased! Everything included is sellable and current. They included more than one size of each style for the most part and a lot of them were full run size packs. Will definitely be ordering this again!",
  reviewDate: "Jul 30, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:56:47.000Z",
    importedBy: "entity-db-cli",
  },
};
